var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaptr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 120,
    viewBox: "0 0 187 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_1564)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H187V187H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8257 94.6446H34.2262V96.4394H38.6402V136.796C38.6402 136.796 39.2805 142.869 34.2262 142.869C29.1718 142.869 29.7151 134.497 29.7151 133.663V51.1154C29.7151 51.1154 29.9867 44.2179 33.5762 44.2179C37.1656 44.2179 41.6573 53.6377 43.1901 71.8081V74.9124H44.9848V43.306H43.1901V45.9544C42.9669 46.0999 42.6565 46.2454 42.3169 46.2454C41.5797 46.2454 38.4559 42.4717 33.8478 42.4717C29.2398 42.4717 22.7109 44.7709 22.7109 54.1616V129.53C22.7109 129.53 21.7019 144.528 34.2165 144.528C34.2165 144.528 37.9902 144.8 42.0356 141.404C42.0356 141.404 44.3348 140.298 44.3348 143.704H46.2653V96.4491H49.8063V94.6543L49.8257 94.6446Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.8 141.851L96.0605 44.1211H89.7159C89.7159 44.1211 80.0535 136.884 80.0535 137.98C80.0535 138.97 79.4035 141.463 76.2119 141.841H75.2223V141.928C75.2223 141.928 75.1932 141.928 75.1738 141.928H75.2223V143.626H86.2623V141.831H85.4571C83.9631 141.734 81.9841 140.745 81.9841 137.786L85.6123 102.774H94.9739L99.1649 141.841H95.2359V143.636H110.835V141.841H106.8V141.851Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8066 100.708L90.2692 58.6533L94.7802 100.708H85.8066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.59 44.082L136.098 44.1111V45.9059H139.959V141.977H136.369V143.771H153.346V141.977H147.691V103.094H154.472C163.979 103.094 164.289 94.1401 164.289 94.1401V54.1422C164.289 44.1402 151.59 44.082 151.59 44.082Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.927 95.4303C156.927 100.892 152.882 100.95 152.882 100.95H147.701V45.9834H151.601C156.267 45.9834 156.937 52.2407 156.937 52.2407V95.4303H156.927Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_1564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 187,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaptr);
export default __webpack_public_path__ + "static/media/Gaptr.d4529e3ea75c292cb58a5a49f7ae461c.svg";
export { ForwardRef as ReactComponent };